module.exports = __webpack_public_path__ + "static/media/zoleWon_500_1000.ac18fed2.png";